import type { SxProps, Theme } from '@mui/material/styles'
import {
  SEVV_DIALOG_PAPER_BACKGROUND_SOLID,
  SEVV_DIALOG_PAPER_BORDER_DIVIDER,
  SEVV_DIALOG_PAPER_SHADOW,
  sevvDialogTitleChromeSx,
} from '../theme/sevvDialogChrome'

/** Reset-password dialog: same shell as app / virtual-room modals (8px radius as px string, tokens, no paper padding). */
export const forgotPasswordDialogPaperSx: SxProps<Theme> = {
  p: 0,
  overflow: 'hidden',
  borderRadius: '8px',
  backgroundColor: SEVV_DIALOG_PAPER_BACKGROUND_SOLID,
  backgroundImage: 'none',
  border: SEVV_DIALOG_PAPER_BORDER_DIVIDER,
  boxShadow: SEVV_DIALOG_PAPER_SHADOW,
}

export const forgotPasswordDialogTitleSx: SxProps<Theme> = {
  ...sevvDialogTitleChromeSx,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  padding: '18px 24px 16px',
  fontWeight: 600,
}

export const forgotPasswordDialogActionsSx: SxProps<Theme> = {
  px: 3,
  py: 2,
  gap: '8px',
  flexShrink: 0,
  borderTop: '1px solid var(--sevv-divider)',
  backgroundColor: 'var(--sevv-dialog-actions-bg)',
}
